<template>
  <v-container
    id="login"
    fluid
    fill-height
    wrap
    pa-0
    :class="'type-' + loginType"
  >
    <v-layout fill-height>
      <v-flex
        xs12
        sm4
        md4
        left
        :class="{ 'small-device': $vuetify.breakpoint.xsOnly }"
      ></v-flex>
      <v-flex xs12 sm8 md8 class="right">
        <v-container fill-height>
          <v-flex xs12 sm12 md8>
            <v-card flat class="xs12 sm8 md8 px-2 transparent">
              <v-card-text>
                <v-img
                  :src="marca"
                  alt="Logo Radiodent"
                  class="mb-3"
                  height="40"
                  contain
                ></v-img>
                <p class="subheading">
                  Bienvenido/a al sistema de Gestión de Pacientes, Examenes e
                  Informes de <strong>RADIODENT</strong>.
                </p>
              </v-card-text>
            </v-card>
            <v-form
              ref="formLogin"
              class="px-4 login"
              v-model="valid"
              v-on:submit.prevent="submitLogin"
              lazy-validation
            >
              <v-card flat class="pa-4">
                <h2 class="text-uppercase">Acceso de {{ loginTypeName }}</h2>

                <v-layout align-center my-2>
                  <!-- v-bind:class="{ 'my-2 pt-1': loginType != 'solicitante' }" -->
                  <div>Ingresar como:</div>

                  <div class="btn-group">
                    <v-btn
                      flat
                      @click="loginType = 'paciente'"
                      :class="{ 'v-btn--active': loginType === 'paciente' }"
                    >
                      Paciente
                    </v-btn>
                    <v-btn
                      flat
                      @click="loginType = 'solicitante'"
                      :class="{ 'v-btn--active': loginType === 'solicitante' }"
                    >
                      Odontólogo
                    </v-btn>
                    <v-btn
                      flat
                      @click="loginType = 'profesional'"
                      :class="{ 'v-btn--active': loginType === 'profesional' }"
                    >
                      Radiólogo
                    </v-btn>
                  </div>
                </v-layout>

                <v-flex xs12 sm8 mt-2>
                  <v-text-field
                    dark
                    prepend-icon="person"
                    name="login"
                    :label="labelUser"
                    type="text"
                    v-model="username"
                    :rules="userRules"
                    required
                  ></v-text-field>

                  <v-text-field
                    dark
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Contraseña"
                    type="password"
                    v-model="password"
                    :rules="passwordRules"
                    required
                  ></v-text-field>

                  <v-flex
                    xs12
                    ma-0
                    pa-0
                    v-bind:class="{ hidden: loginType != 'solicitante' }"
                  >
                    <!-- v-if="loginType == 'solicitante'" -->
                    <v-btn
                      depressed
                      class="mx-0 my-2 pa-0 forget btn-hover-orange"
                      color="transparent caption"
                      @click="dialog = !dialog"
                      >Restaurar contraseña</v-btn
                    >

                    <!-- v-if="loginType == 'solicitante'" -->
                    <v-btn
                      depressed
                      class="mx-5 my-2 pa-0 forget btn-hover-orange"
                      color="transparent caption"
                      @click="dialogRequest = !dialogRequest"
                      >Solicitar cuenta</v-btn
                    >
                    <!-- <v-btn v-else class="mx-0 my-2 forget pa-0 hidden">...</v-btn> -->
                  </v-flex>
                  <!-- Restaurar contrasña -->
                </v-flex>
              </v-card>

              <v-spacer></v-spacer>
              <v-btn
                dark
                class="mx-0 px-5 enter subheading"
                :disabled="!valid"
                type="submit"
                >Ingresar</v-btn
              >
            </v-form>
          </v-flex>
        </v-container>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="400">
        <v-form
          ref="formRecovery"
          class="recovery"
          v-on:submit.prevent="submitRecovery"
          lazy-validation
        >
          <v-card class="px-3">
            <v-card-title primary-title>
              <div class="subheading font-weight-bold text-uppercase">
                Recuperar Contraseña
              </div>
              <div>Ingrese el correo electrónico de inicio de sesión</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                color="#ff8303"
                prepend-icon="person"
                name="recovery"
                label="Correo"
                type="text"
                v-model="recovery"
                :rules="emailRules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outline
                small
                color="grey darken-1"
                @click.native="dialog = false"
                >Cancelar</v-btn
              >
              <v-btn
                outline
                small
                color="#ff8303"
                type="submit"
                @click.native="dialog = false"
                >Recuperar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogRequest" persistent max-width="400">
        <v-form
          ref="formRequest"
          class="recovery"
          v-on:submit.prevent="submitRequest"
          lazy-validation
        >
          <v-card class="px-3">
            <v-card-title primary-title>
              <div class="subheading font-weight-bold text-uppercase">
                Solicitar Cuenta de Odontólogo
              </div>
              <div>
                Ingrese los siguientes datos para solicitar su cuenta de
                usuario.
              </div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                color="#ff8303"
                prepend-icon="person"
                name="requestName"
                label="Nombres"
                type="text"
                v-model="requestName"
                :rules="textRules"
              ></v-text-field>
              <v-text-field
                color="#ff8303"
                prepend-icon="person"
                name="requestLastName"
                label="Apellidos"
                type="text"
                v-model="requestLastName"
                :rules="textRules"
              ></v-text-field>
              <v-text-field
                color="#ff8303"
                prepend-icon="person"
                name="requestMail"
                label="Correo"
                type="text"
                v-model="requestMail"
                :rules="emailRules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outline
                small
                color="grey darken-1"
                @click.native="dialogRequest = false"
                >Cancelar</v-btn
              >
              <v-btn outline small color="#ff8303" type="submit"
                >Solicitar</v-btn
              >
              <!-- @click.native="dialogRequest = false" -->
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-snackbar v-model="snackbar" :bottom="true" :multi-line="true">
        {{ snackbarText }}
        <v-btn color="pink" flat @click="snackbar = false">
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
#login {
  .hidden {
    visibility: hidden;
    transition: none !important;
    * {
      transition: none !important;
    }
  }
  .left {
    background-color: #000000;
    background: url("/img/radiodent1.jpg") center center repeat;
    background-size: cover;
    background-position-x: right;
    &.small-device {
      min-height: 20%;
      background-position-y: bottom;
    }
  }
  .right {
    background-size: 100% auto;
    .theme--dark.v-label {
      top: 0;
    }
    .theme--dark.v-label {
      color: #616161 !important;
    }
    .v-btn.v-btn--active {
      background-color: #395261;
      color: white;
    }
    .theme--dark.v-input:not(.v-input--is-disabled) input,
    .theme--dark.v-input:not(.v-input--is-disabled) textarea {
      color: #395261;
      background-color: white;
    }
  }
  &.type-paciente .right {
    background-color: #eeeeee;
  }
  &.type-profesional .right {
    background-color: #18afd3;
  }
  &.type-solicitante .right {
    background-color: #b9eaf7;
  }
  .login button.v-btn.enter:focus,
  .login button.v-btn.enter:focus::before,
  .login button.v-btn.enter:hover,
  .login button.v-btn.enter:hover::before {
    background-color: #ff8303 !important;
  }
  .login button.v-btn.enter div {
    letter-spacing: 0.1rem;
    text-transform: none !important;
  }
  .login button.v-btn.forget:focus,
  .login button.v-btn.forget:focus::before,
  .login button.v-btn.forget:hover,
  .login button.v-btn.forget:hover::before {
    background-color: transparent !important;
  }
  .login button.v-btn.forget div {
    letter-spacing: 0.1rem;
    text-transform: none !important;
  }
  .login button.v-btn.forget:focus div,
  .login button.v-btn.forget:hover div {
    text-decoration: underline !important;
  }
  .login button.v-btn.forget span {
    display: none !important;
  }
  .recovery button.v-btn.enter:focus,
  .recovery button.v-btn.enter:focus::before,
  .recovery button.v-btn.enter:hover,
  .recovery button.v-btn.enter:hover::before {
    background-color: #ff8303 !important;
  }
  .theme--light.v-tabs__bar,
  .theme--light.v-sheet {
    background-color: transparent;
  }
  .v-input--switch__thumb,
  .v-input--switch__track {
    color: #eeeeee;
    caret-color: #eeeeee;
  }
  .btn-hover-orange {
    color: #f57e57;
    :hover {
      color: #ff1c03;
    }
  }
}
</style>

<script>
import axios from "axios";
import { bus } from "./../main";
export default {
  created() {},
  mounted() {
    if (localStorage.isLogged === "true") {
      this.$router.push({ name: "Home" });
    } else {
      this.clear();
    }
    if (this.$route.query.message) {
      this.snackbarText = this.$route.query.message;
      this.snackbar = true;
    }
  },
  data: () => ({
    drawer: null,
    marca: "/img/logo-radiodent.png",
    dialog: false,
    valid: true,
    bgColor: "warning",
    username: "",
    userRules: [(v) => !!v || "Usuario es requerido"],
    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || "El correo debe ser válido",
    ],
    textRules: [(v) => !!v || "Valor es requerido"],
    password: "",
    passwordRules: [(v) => !!v || "Password es requerido"],
    recovery: "",
    snackbar: false,
    snackbarText: "",
    swithType: null,
    loginType: "paciente",
    dialogRequest: false,
    requestName: "",
    requestLastName: "",
    requestMail: "",
  }),
  props: {
    source: String,
  },
  computed: {
    colorDivider() {
      // console.log(this.loginType);
      let color = this.loginType == "profesional" ? "#18afd3" : "#eeeeee";
      // console.log(color);
      return color;
    },
    loginTypeName() {
      // console.log("Login Type", this.loginType);
      if (this.loginType == "paciente") {
        return "Paciente";
      }
      if (this.loginType == "solicitante") {
        return "Odontólogo";
      }
      if (this.loginType == "profesional") {
        return "Radiólogo";
      }
      return "";
    },
    labelUser() {
      return this.loginType == "solicitante" ? "Correo" : "Usuario";
    },
  },
  methods: {
    submitLogin: function() {
      if (this.$refs.formLogin.validate()) {
        var that = this;

        /* DEBUG */
        var debug = false;

        const setSession = axios.create({
          timeout: 10000,
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "x-www-form-urlencoded",
          },
          params: {
            accion: "sesion",
            login: this.username,
            password: this.password,
            type: this.loginType,
          },
        });

        setSession
          .post(window.base_path + window.ws)
          .then((result) => {
            // console.log(result, result.data.response, result.data.callback);
            if (debug) {
              // result.data.response = true;
              // result.data.callback = fakeuser;
            }

            that.snackbarText = result.data.message;
            that.snackbar = true;

            if (result.data.response) {
              localStorage.clear();

              setTimeout(() => {
                bus.$emit("userStatus", {
                  isLogged: true,
                  logged_user: result.data.callback,
                });
              }, 1000);
            }
          })
          .catch((error) => {
            // console.log(error)
            if (error.response) {
              that.snackbarText =
                "Algo anda mal! (cod: " + error.response.status + ").";
            } else if (error.request) {
              that.snackbarText = "Algo anda mal con la validación.";
            } else {
              that.snackbarText = "Algo anda mal con el sistema.";
            }
            that.snackbar = true;

            setTimeout(() => {
              bus.$emit("userStatus", { isLogged: false });
            }, 1000);
          });
      } else {
        // console.log('No valido')
      }
    },
    clear: function() {
      this.$refs.formLogin.reset();
      this.$refs.formRecovery.reset();
      this.$refs.formRequest.reset();
    },
    submitRecovery: function() {
      if (this.$refs.formRecovery.validate()) {
        var that = this;

        /* DEBUG */
        var debug = false;

        const setRecovery = axios.create({
          timeout: 10000,
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "x-www-form-urlencoded",
          },
          params: {
            accion: "recuperarClaveSolicitante",
            login: this.recovery,
          },
        });

        setRecovery
          .post(window.base_path + window.ws)
          .then((result) => {
            // console.log(result, result.data.response, result.data.callback);
            if (debug) {
              // result.data.response = true;
              // result.data.callback = fakeuser;
            }

            that.snackbarText = result.data.callback.message; //"Correo enviado! =)";
            that.snackbar = true;
          })
          .catch((error) => {
            // console.log(error)
            if (error.response) {
              that.snackbarText =
                "Algo anda mal! (cod: " + error.response.status + ").";
            } else if (error.request) {
              that.snackbarText = "Algo anda mal con la validación.";
            } else {
              that.snackbarText = "Algo anda mal con el sistema.";
            }
            that.snackbar = true;

            // setTimeout(() => {
            //   bus.$emit("userStatus", { isLogged: false });
            // }, 1000);
          });
      } else {
        // console.log('No valido')
      }
    },
    submitRequest: function() {
      if (this.$refs.formRequest.validate()) {
        var that = this;

        /* DEBUG */
        var debug = false;
        //accion=solicitarCuentaSolicitante&correo=nombrecorreo@prueba.cl& nombres=Mario&apellidos=Gonzalez
        const setRequest = axios.create({
          timeout: 10000,
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "x-www-form-urlencoded",
          },
          params: {
            accion: "solicitarCuentaSolicitante",
            correo: this.requestMail,
            nombres: this.requestName,
            apellidos: this.requestLastName,
          },
        });

        setRequest
          .post(window.base_path + window.ws)
          .then((result) => {
            that.snackbarText = result.data.message; //"Correo enviado! =)";
            that.snackbar = true;
            that.dialogRequest = false;
          })
          .catch((error) => {
            // console.log(error)
            if (error.response) {
              that.snackbarText =
                "Algo anda mal! (cod: " + error.response.status + ").";
            } else if (error.request) {
              that.snackbarText = "Algo anda mal con la validación.";
            } else {
              that.snackbarText = "Algo anda mal con el sistema.";
            }
            that.snackbar = true;

            // setTimeout(() => {
            //   bus.$emit("userStatus", { isLogged: false });
            // }, 1000);
          });
      } else {
        // console.log('No valido')
      }
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
